import React, { useState, useEffect } from 'react';
import flowerbg from '../../assets/flowerbg.png';
import logo from '../../assets/logo.png';
import {
  CountryDropdown,
  CountryRegionData,
} from 'react-country-region-selector';
import { useDispatch, useSelector } from 'react-redux';
import { register } from '../../features/auth/auth.slice';
import Spinner from '../utilities/Spinner';
import { toast } from 'react-toastify';

const Register = ({ setAuthType }) => {
  const [country, selectCountry] = useState('');
  const [data, setData] = useState({
    email: '',
    password: '',
    address: '',
    name: '',
  });
  const dispatch = useDispatch();
  const { loading, isRegistered } = useSelector((state) => state.auth);
  useEffect(() => {
    if (isRegistered) {
      setAuthType('login');
      return;
    }
  }, [isRegistered]);

  const submitData = () => {
    if (
      data.email.length === 0 ||
      data.password.length === 0 ||
      data.address.length === 0 ||
      data.name.length === 0
    ) {
      console.log(data);
      toast.error('Please enter valid credentials');
      return;
    }
    dispatch(register(data));
  };
  return (
    <>
      <>
        <img src={logo} alt="Postager Logo" />
        <p className="font-semibold">Create An Account</p>
      </>
      <form
        className="space-y-5 px-7 w-full pt-5"
        onSubmit={(e) => {
          e.preventDefault();
          submitData();
        }}
      >
        <input
          type="text"
          class="bg-gray-50 border border-gray-400 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full p-2"
          placeholder="Enter Your Name"
          onChange={(e) => {
            setData({
              ...data,
              name: e.target.value,
            });
          }}
          required
        />

        <input
          type="email"
          class="bg-gray-50 border border-gray-400 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full p-2"
          placeholder="Enter Your Email"
          onChange={(e) => {
            setData({
              ...data,
              email: e.target.value,
            });
          }}
          required
        />

        <CountryDropdown
          className="p-2 bg-white w-full rounded-md border border-gray-400"
          value={data.address}
          onChange={(val) =>
            setData({
              ...data,
              address: val,
            })
          }
        />
        <div>
          <input
            type="password"
            class="bg-gray-50 border border-gray-400 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full p-2"
            placeholder="Password"
            onChange={(e) => {
              setData({
                ...data,
                password: e.target.value,
              });
            }}
            required
          />
          <a
            href="#"
            className="text-sm pt-1 float-right mb-3 hover:underline"
            onClick={() => setAuthType('forgotpassword')}
          >
            Forgot Password
          </a>
        </div>

        <div className="flex flex-col justify-center items-center w-full space-y-3">
          <button
            className={`text-white   focus:ring-4 ${
              loading ? 'bg-blue-300' : 'bg-darkblue hover:bg-blue-800'
            } focus:outline-none focus:ring-blue-300 font-medium rounded-md text-sm w-full px-5 py-2 text-center self-center mt-5 flex justify-center`}
            type="submit"
            disabled={loading}
          >
            {loading ? <Spinner sm={true} /> : 'Register'}
          </button>
          <button className="text-black bg-white border border-gray-400 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-md text-sm w-[85%] px-5 py-2.5 text-center flex justify-center items-center">
            <img
              src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/google/google-original.svg"
              className="h-5 w-5 mr-1"
            />
            Sign Up With Google
          </button>

          <a
            href="#"
            className="text-sm hover:underline"
            onClick={() => setAuthType('login')}
          >
            Already Have An Account? Login
          </a>
        </div>
      </form>
    </>
  );
};

export default Register;
